<ng-template #templateRef>
  <div class="tab-content">
    <ng-content />
  </div>
</ng-template>
